import { WModalContent } from "@/components/modal/WModal.tsx";

export function WarningModal({ modalAction }: { modalAction: () => void }) {
    return (
        <WModalContent title="Are you sure you want to navigate away?" label="Navigate Away" modalAction={modalAction}>
            You have unpublished prices, any unpublished changes you have made will be lost when navigating away.
        </WModalContent>
    );
}
